import React, {useState} from 'react'
import {FormControl, TextField} from '@material-ui/core';
import {useFieldWithValidation} from "../../../../hooks";
import CreateDialog from "./CreateDialog";

const CreateTextDialog = ({open, body, label, handleClose, handleSave, ...props}) => {
    const [text, setText] = useState(null);
    const {reset: resetTextValue, validate: validateTextValue, ...textValue} = useFieldWithValidation(
        "text",
        text || "",
        null,
        false
    );

    const save = () => {
        handleSave(text);
    }

    return (
        <CreateDialog
            open={open}
            body={""}
            label={label}
            handleClose={handleClose}
            handleSave={save}
        >
            <FormControl fullWidth>
                <TextField
                    variant="outlined"
                    {...textValue}
                    onBlur={({target:{ name, value }}) => setText(value)}
                    label={label}
                    maxLength={40}
                    autoFocus
                />
            </FormControl>
        </CreateDialog>
    )
}

export default CreateTextDialog;